import React, { memo, useCallback } from 'react'
import '../index.css'

const RifterThumb = memo(({ rifter, listArticles, issueTitle }) => {
  const { issue } = rifter

  const handleClick = useCallback(() => {
    return listArticles(issueTitle)
  }, [listArticles, issueTitle])

  return (
    <div className='thumb-image-container'>
      <button 
        onClick={handleClick}
        aria-label={`Search for articles in ${issueTitle}`}
        type='button'
      >
        <img src={issue} alt={`Cover of ${issueTitle}`} loading="lazy" />
      </button>
      <div className='rifter-thumb-title'>{issueTitle}</div>
    </div>
  )
})

RifterThumb.displayName = 'RifterThumb'

export default RifterThumb
